export default __webpack_public_path__ + "static/media/Kannada_cf_1.6ac5b430.mp3";